/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import {
  InputItem, List, Picker, Button, Modal, PickerView, DatePicker, Toast,
} from 'antd-mobile';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import { inject, observer } from 'mobx-react';
import styles from './index.module.less';
import Information from './image/information.png';
import Buying from './image/buying.png';
import {
  getCarColor, getCustomer, getAreaInfo, AddCustomer,
} from '../../service/car-service';
import tools from '../../utils/tools';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  modal: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  }),
  // eslint-disable-next-line react/forbid-prop-types,react/require-default-props
  modalChildren: PropTypes.shape({
    specId: PropTypes.number,
    specName: PropTypes.specName,
  }),
};

const defaultProps = {
};
const Gender = [
  {
    label: '男',
    value: 0,
  },
  {
    label: '女',
    value: 1,
  },
];
const list = [
  {
    label: '否',
    value: 0,
  },
  {
    label: '是',
    value: 1,
  },
];
const loanList = [
  {
    label: '未知',
    value: 0,
  },
  {
    label: '否',
    value: 1,
  },
  {
    label: '是',
    value: 2,
  },
];
@inject('CustomerDetail')
@observer
class CustomerDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customerDetailInfo: {
        userId: tools.getQueryString('userId'),
      },
      appearanceColor: [],
      innerColor: [],
      aiInfo: {},
      addressList: [[], [], []],
      pickerValue: [[], [], []],
      isShow: null,
      cityList: [[], []],
      cityValue: [[], []],
    };
    this.inp = React.createRef();
  }

  componentDidMount() {
    const { CustomerDetail: customer } = this.props;
    if (customer.customerValue.userId) {
      console.log(customer.customerValue.appbrandName);
      this.setState({
        customerDetailInfo: customer.customerValue,
        pickerValue: customer.customerValue.addressProvinceName ? [
          [{ label: customer.customerValue.addressProvinceName, value: `${customer.customerValue.addressProvinceId}` }],
          [{ label: customer.customerValue.addressCityName, value: `${customer.customerValue.addressCityId}` }],
          [{ label: customer.customerValue.addressDistrictName, value: `${customer.customerValue.addressDistrictId}` }],
        ] : [[], [], []],
        cityValue: customer.customerValue.appRegProvinceName ? [
          [{ label: customer.customerValue.appRegProvinceName, value: customer.customerValue.appRegProvinceId }],
          [{ label: customer.customerValue.appRegCityName, value: customer.customerValue.appRegCityId }],
        ] : [[], []],
      }, () => {
        this.getCarColorList();
        this.loadArea();
        this.loadArea2();
      });
    } else {
      this.loadDate();
      this.loadArea();
      this.loadArea2();
    }
  }

  getCarColorList = async () => {
    const { customerDetailInfo } = this.state;
    const params = { specId: customerDetailInfo.appSpecId };
    try {
      const { data } = await getCarColor(params);
      const appearanceColor = data?.appearanceColor ? data.appearanceColor.map((item) => ( // 外观颜色信息
        { label: item.name, value: item.id }
      )) : [];
      const innerColor = data?.innerColor ? data.innerColor.map((item) => ( // 内饰颜色信息
        { label: item.name, value: item.id }
      )) : [];
      this.setState({
        appearanceColor,
        innerColor,
      });
    } catch (err) {
      console.log(err);
    }
  }

  /**
   *加载数据
   */
  loadDate = async () => {
    const phone = tools.getQueryString('phone');
    const weChat = tools.getQueryString('weChat');
    if (!weChat) return;// 必须有 没有不请求
    let { pickerValue } = this.state;
    try {
      const { data, code } = await getCustomer({ phone, weChat });
      if (code === '10000') {
        if (data?.aiInfo?.addressProvinceId || data?.info?.addressProvinceId) {
        // 如果有ai识别出来的结果
          pickerValue = data?.aiInfo?.addressProvinceId ? [
            [
              {
                value: data.aiInfo.addressProvinceId, label: `${data.aiInfo.addressProvinceName}`,
              },
            ],
            [{
              label: data.aiInfo.addressCityName, value: `${data.aiInfo.addressCityId}`,
            }],
            [
              {
                label: data.aiInfo.addressDistrictName, value: `${data.aiInfo.addressDistrictId}`,
              },
            ],
          ] : [
            [
              {
                value: data.info.addressProvinceId, label: `${data.info.addressProvinceName}`,
              },
            ],
            [{
              label: data.info.addressCityName, value: `${data.info.addressCityId}`,
            }],
            [
              {
                label: data.info.addressDistrictName, value: `${data.info.addressDistrictId}`,
              },
            ],
          ];
        }
        this.setState({
          customerDetailInfo: { ...data.info, userId: tools.getQueryString('userId') },
          aiInfo: (data && data.aiInfo) ? data.aiInfo : {},
          pickerValue,
          cityValue: data && data.info ? [
            [
              { label: data.info.appRegProvinceName, value: `${data.info.appRegProvinceId}` }], [{ label: data.info.appRegCityName, value: `${data.info.appRegCityId}` }]] : [[], []],
        }, () => {
          this.getCarColorList();
          this.loadArea();
          this.loadArea2();
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * 地址查询
   * @param {number} index 列数
   * @param {array} value 已选中
   */
  loadArea = (index = -1, value) => {
    const { addressList, pickerValue } = this.state;
    const pVal = addressList[index]?.filter((v) => v.value === value[0])?.[0];
    if (index !== -1) pickerValue[index] = pVal || [];
    const query = { query: { [index === 0 ? 'pid' : 'cid']: pickerValue[index]?.value } };
    if (index >= addressList.length - 1) return;
    getAreaInfo(query).then((res) => {
      if (res.code === '10000') {
        addressList[index + 1] = res.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        // 获取下一列的第一个或者是默认值，然后进行递归
        const nextValue = pickerValue[index + 1][0] || addressList[index + 1][0];// 如果有值回显如果没有默认取第一个
        pickerValue[index + 1] = nextValue;
        this.loadArea(index + 1, [nextValue.value]);
        this.setState({ addressList, pickerValue });
      }
    });
  }

  /**
   * 地址查询
   * @param {number} index 列数
   * @param {array} value 已选中
   */
  loadArea2 = (index = -1, value) => {
    const { cityList, cityValue } = this.state;
    const pVal = cityList[index]?.filter((v) => v.value === value[0])?.[0];
    if (index !== -1) cityValue[index] = pVal || [];
    const query = { query: { [index === 0 ? 'pid' : 'cid']: cityValue[index]?.value } };
    if (index >= cityList.length - 1) return;
    getAreaInfo(query).then((res) => {
      if (res.code === '10000') {
        cityList[index + 1] = res.data.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        // 获取下一列的第一个或者是默认值，然后进行递归
        const nextValue = cityValue[index + 1][0] || cityList[index + 1][0];// 如果有值回显如果没有默认取第一个
        cityValue[index + 1] = nextValue;
        this.loadArea2(index + 1, [nextValue.value]);
        this.setState({ cityList, cityValue });
      }
    });
  }

  handleChangeInfo = (type) => (event) => {
    const { aiInfo, customerDetailInfo } = this.state;
    let value = null;
    if (Array.isArray(event)) {
      value = event.join(',');
      this.setState({
        aiInfo: {
          ...aiInfo,
          [type]: value,
        },
        customerDetailInfo: {
          ...customerDetailInfo,
          [type]: value,
        },
      });
    } else {
      this.setState({
        aiInfo: {
          ...aiInfo,
          [type]: event,
        },
        customerDetailInfo: {
          ...customerDetailInfo,
          [type]: event,
        },
      });
    }
  }

  /**
   * 重置
   */
  handelReset = (callback) => {
    this.setState(
      {
        customerDetailInfo: {},
        addressList: [[], [], []],
        pickerValue: [[], [], []],
        cityList: [[], []],
        cityValue: [[], []],
      },
      () => {
        callback();
      },
    );
  }

  /**
   * 保存
   */
  handleChangeSubmit = () => {
    const {
      customerDetailInfo, appearanceColor, innerColor, aiInfo,
    } = this.state;
    const detail = customerDetailInfo;
    const data = appearanceColor.find((item) => item.value === Number(customerDetailInfo.carColorId));
    const object = innerColor.find((item) => item.value === Number(customerDetailInfo.interiorColorId));
    detail.carColorId = data ? data.value : customerDetailInfo.carColorId;
    detail.carColorName = data ? data.label : customerDetailInfo.carColorName;
    detail.interiorColorId = object ? object.value : customerDetailInfo.interiorColorId;
    detail.interiorColorName = object ? object.label : customerDetailInfo.interiorColorName;
    detail.toDealerTime = customerDetailInfo.toDealerTime ? format(new Date(customerDetailInfo.toDealerTime), 'yyyy-MM-dd HH:mm:ss') : '';
    detail.buyCarTime = customerDetailInfo.buyCarTime ? format(new Date(customerDetailInfo.buyCarTime), 'yyyy-MM-dd HH:mm:ss') : '';
    detail.weChat = tools.getQueryString('weChat');
    detail.appPhone = tools.getQueryString('phone');
    const Obj = { ...detail, ...aiInfo };
    const status = [];
    Object.keys(Obj).map((v) => {
      if (v === 'weChat' || v === 'userId' || v === 'companyCode' || v === 'dealerId') return v;
      if (Obj[v]) {
        status.push(Obj[v]);
      }
      return v;
    });
    if (status.length === 0) {
      Toast.show('请填写客户信息');
      return;
    }
    const params = { info: Obj };
    AddCustomer(params).then((res) => {
      if (res.code === '10000') {
        Toast.show('保存成功');
        this.handelReset(this.loadDate);
      } else {
        Toast.show('保存失败');
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  handleChangeInput = (type) => (event) => {
    const { customerDetailInfo } = this.state;
    if (Array.isArray(event)) {
      this.setState({
        customerDetailInfo: {
          ...customerDetailInfo,
          [type]: event.join(','),
        },
      });
    } else {
      this.setState({
        customerDetailInfo: {
          ...customerDetailInfo,
          [type]: event,
        },
      });
    }
  }

  handleChangeHistory = () => {
    this.handleInputBlur();
    const { CustomerDetail: customer } = this.props;
    const { customerDetailInfo } = this.state;
    customer.setCustomerValue(customerDetailInfo);// 存储到mobx
    const { history } = this.props;
    const token = tools.getQueryString('token');
    const userId = tools.getQueryString('userId');
    const phone = tools.getQueryString('phone');
    const weChat = tools.getQueryString('weChat');
    history.push(`/model?token=${token}&userId=${userId}&phone=${phone}&weChat=${weChat}`);
  }

  handleInputBlur = () => {
    const alldom = document.querySelectorAll('input');
    alldom.forEach((v) => {
      v.blur();
    });
  }

  handleChangeOnclose = () => {
    this.setState({
      isShow: false,
    });
  }

  handleChangeOk = () => {
    const { cityValue, customerDetailInfo } = this.state;
    const data = {
      appRegProvinceName: cityValue[0].label || '',
      appRegProvinceId: cityValue[0].value || '',
      appRegCityName: cityValue[1].label || '',
      appRegCityId: cityValue[1].value || '',
    };
    Object.keys(data).map((v) => {
      customerDetailInfo[v] = data[v];
      return v;
    });
    this.setState({
      isShow: null,
      customerDetailInfo,
    });
  }

  handleChangeOkAddressList = () => {
    const { pickerValue, aiInfo, customerDetailInfo } = this.state;
    if (aiInfo.addressCityId) {
      aiInfo.addressProvinceName = pickerValue[0].label || '';
      aiInfo.addressProvinceId = pickerValue[0].value || '';
      aiInfo.addressCityName = pickerValue[1].label || '';
      aiInfo.addressCityId = pickerValue[1].value || '';
      aiInfo.addressDistrictName = pickerValue[2].label || '';
      aiInfo.addressDistrictId = pickerValue[2].value || '';
    }
    const data = {
      addressProvinceName: pickerValue[0].label || '',
      addressProvinceId: pickerValue[0].value || '',
      addressCityName: pickerValue[1].label || '',
      addressCityId: pickerValue[1].value || '',
      addressDistrictName: pickerValue[2].label || '',
      addressDistrictId: pickerValue[2].value || '',
    };
    Object.keys(data).map((v) => {
      customerDetailInfo[v] = data[v];
      return v;
    });
    this.setState({
      isShow: null,
      customerDetailInfo,
    });
  }

  handleChangeShow = (value) => {
    this.handleInputBlur();
    this.setState({
      isShow: value,
    });
  }

  render() {
    const {
      customerDetailInfo, appearanceColor,
      innerColor, addressList, aiInfo, pickerValue, isShow, cityList, cityValue,
    } = this.state;
    // const { CustomerDetail: customer } = this.props;
    const phone = tools.getQueryString('phone');
    return (
      <div className={styles.box}>
        <div style={{ height: '20px' }} />
        <div className={styles.basic}>
          <img src={Information} alt="" />
          <p>
            基本信息
          </p>
        </div>
        <div>
          <List>
            <InputItem
              className={styles.input}
              ref={this.inp}
              type="right"
              value={aiInfo.aliasName || customerDetailInfo.aliasName}
              placeholder="请输入客户姓名"
              moneyKeyboardAlign="right"
              onChange={aiInfo.aliasName ? this.handleChangeInfo('aliasName') : this.handleChangeInput('aliasName')}
              maxLength={10}
            >
              客户姓名
            </InputItem>
          </List>
          <List onClick={this.handleInputBlur}>
            <Picker
              data={Gender}
              value={[aiInfo.gender !== undefined ? Number(aiInfo.gender) : Number(customerDetailInfo.gender)]}
              cols={1}
              onChange={aiInfo.gender !== undefined ? this.handleChangeInfo('gender') : this.handleChangeInput('gender')}
            >
              <List.Item style={{ color: '#ADADAD' }}>
                性别
                {
                  aiInfo.loan !== undefined && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </Picker>
          </List>
          {
            phone && phone !== 'null' ? (
              <List>
                <InputItem
                  className={styles.input}
                  type="right"
                  disabled
                  value={phone}
                  maxLength={11}
                  moneyKeyboardAlign="right"
                  onChange={this.handleChangeInput('appPhone')}
                >
                  手机号
                </InputItem>
              </List>
            )
              : (
                <List>
                  <InputItem
                    className={styles.input}
                    type="right"
                    disabled
                    maxLength={11}
                    moneyKeyboardAlign="right"
                    onChange={this.handleChangeInput('appPhone')}
                  >
                    手机号
                  </InputItem>
                </List>
              )
          }

          <List>
            <List.Item onClick={this.handleChangeHistory}>
              意向车型
              {' '}
              {aiInfo.appSeriesName && <span style={{ margin: '0 10px', color: '#15D192' }}> AI 识别为 </span> }
              <p style={{
                flex: 1, overflow: 'auto', marginLeft: 10, textAlign: 'right',
              }}
              >
                {aiInfo.appSeriesName || (customerDetailInfo.appbrandName ? `${customerDetailInfo.appbrandName} ${customerDetailInfo.appSeriesName} ${customerDetailInfo.appSpecName}` : false) || '请选择'}
              </p>

            </List.Item>
          </List>
          <List>
            <List.Item onClick={() => this.handleChangeShow('city')}>
              上牌城市
              {' '}
              {
                aiInfo.appRegProvinceName && <span style={{ marginLeft: '60px', color: '#15D192' }}> AI 识别为 </span>
              }
              <p style={{ float: 'right' }}>
                {`${
                  aiInfo.appRegProvinceName || customerDetailInfo.appRegProvinceName || '请选择'}
                ${aiInfo.appRegCityName || customerDetailInfo.appRegCityName || ''}` }
              </p>
            </List.Item>
          </List>
          {
            aiInfo.addressProvinceName ? (
              <List>
                <List.Item onClick={() => this.handleChangeShow('address')}>
                  地址
                  { aiInfo.addressProvinceName && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>}
                  <p>
                    {`${aiInfo.addressProvinceName}${aiInfo.addressCityName}${aiInfo.addressDistrictName || '请选择'}`}
                  </p>
                </List.Item>
              </List>
            ) : (
              <List>
                <List.Item onClick={() => this.handleChangeShow('address')}>
                  地址
                  <p>
                    {`${customerDetailInfo.addressProvinceName || '请选择'}${customerDetailInfo.addressCityName || ''}${customerDetailInfo.addressDistrictName || ''}`}
                  </p>
                </List.Item>
              </List>
            )
          }

        </div>
        <div style={{ height: '20px' }} />
        <div className={styles.basic}>
          <img src={Buying} alt="" />
          <p>购车意向</p>
        </div>
        <div style={{ paddingBottom: '90px' }}>
          <List onClick={this.handleInputBlur}>
            <DatePicker
              className={styles.input}
              type="right"
              value={aiInfo.buyCarTime ? new Date(aiInfo.buyCarTime) : customerDetailInfo.buyCarTime ? new Date(customerDetailInfo.buyCarTime) : ''}
              moneyKeyboardAlign="right"
              onChange={aiInfo.buyCarTime ? this.handleChangeInfo('buyCarTime') : this.handleChangeInput('buyCarTime')}
            >
              <List.Item>
                购车时间
                {
                  aiInfo.buyCarTime && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </DatePicker>
          </List>
          <List onClick={this.handleInputBlur}>
            <Picker
              data={list}
              value={[aiInfo.isArrived !== undefined ? Number(aiInfo.isArrived) : Number(customerDetailInfo.isArrived)]}
              cols={1}
              onChange={aiInfo.isArrived !== undefined ? this.handleChangeInfo('isArrived') : this.handleChangeInput('isArrived')}
            >
              <List.Item style={{ color: '#ADADAD' }}>
                是否到店
                {
                  aiInfo.isArrived !== undefined && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </Picker>
          </List>
          <List onClick={this.handleInputBlur}>
            <Picker
              data={loanList}
              value={[aiInfo.loan !== undefined ? Number(aiInfo.loan) : Number(customerDetailInfo.loan)]}
              cols={1}
              onChange={aiInfo.loan !== undefined ? this.handleChangeInfo('loan') : this.handleChangeInput('loan')}
            >
              <List.Item style={{ color: '#ADADAD' }}>

                是否贷款
                {
                  aiInfo.loan !== undefined && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </Picker>
          </List>
          <List onClick={this.handleInputBlur}>
            <Picker
              data={list}
              value={[aiInfo.isTestDrive !== undefined ? Number(aiInfo.isTestDrive) : Number(customerDetailInfo.isTestDrive)]}
              cols={1}
              onChange={this.handleChangeInput('isTestDrive')}
            >
              <List.Item style={{ color: '#ADADAD' }}>
                是否试驾
                {
                  aiInfo.isTestDrive !== undefined && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </Picker>
          </List>
          <List onClick={this.handleInputBlur}>
            <InputItem
              className={styles.input}
              type="digit"
              value={aiInfo.budget || customerDetailInfo.budget}
              moneyKeyboardAlign="right"
              extra="万元"
              onChange={aiInfo.budget ? this.handleChangeInfo('budget') : this.handleChangeInput('budget')}
            >
              购车预算
              {' '}
              {
                aiInfo.budget && <span style={{ marginLeft: '10px', color: '#15D192' }}>AI识别为</span>
              }
              {' '}
            </InputItem>

          </List>
          <List onClick={this.handleInputBlur}>
            <Picker
              data={innerColor}
              value={[Number(aiInfo.interiorColorId) || Number(customerDetailInfo.interiorColorId)]}
              cols={1}
              onChange={aiInfo.interiorColorId ? this.handleChangeInfo('interiorColorId') : this.handleChangeInput('interiorColorId')}
            >
              <List.Item>
                车辆颜色
                {
                  aiInfo.interiorColorId && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </Picker>
          </List>
          <List onClick={this.handleInputBlur}>
            <Picker
              data={appearanceColor}
              value={[Number(aiInfo.carColorId) || Number(customerDetailInfo.carColorId)]}
              cols={1}
              onChange={aiInfo.carColorId ? this.handleChangeInfo('carColorId') : this.handleChangeInput('carColorId')}
            >
              <List.Item>
                内饰颜色
                {
                  aiInfo.carColorId && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </Picker>
          </List>
          <List onClick={this.handleInputBlur}>
            <DatePicker
              className={styles.input}
              type="right"
              value={aiInfo.toDealerTime ? new Date(aiInfo.toDealerTime) : customerDetailInfo.toDealerTime ? new Date(customerDetailInfo.toDealerTime) : ''}
              moneyKeyboardAlign="right"
              onChange={aiInfo.toDealerTime ? this.handleChangeInfo('toDealerTime') : this.handleChangeInput('toDealerTime')}
            >
              <List.Item>
                到店时间
                {
                  aiInfo.toDealerTime && <span style={{ marginLeft: '10px', color: '#15D192' }}> AI 识别为 </span>
                }
              </List.Item>
            </DatePicker>
          </List>
        </div>
        <div className={styles.footer}>
          <Button className={styles.submit} onClick={this.handleChangeSubmit}>保存</Button>
        </div>
        {
          isShow === 'address' && (
            <Modal
              popup
              visible
              animationType="slide-up"
              maskClosable={false}
            >
              <div className={styles.headers}>
                <div
                  role="button"
                  tabIndex="0"
                  className={styles.headerFont}
                  onClick={this.handleChangeOnclose}
                >
                  取消
                </div>
                <p className={styles.textTwo}>
                  我的地址
                </p>
                <div role="button" tabIndex="0" className={styles.text} onClick={this.handleChangeOkAddressList}>
                  确定
                </div>
              </div>
              <div className={styles.pickers}>
                {addressList.map((item, index) => (
                  <PickerView
                    key={item[0]?.value || index}
                    onChange={this.loadArea.bind(this, index)}
                    data={item}
                    value={pickerValue[index]?.value?.split(',')}
                    cascade={false}
                  />
                ))}
              </div>
            </Modal>
          )
        }
        {
          isShow === 'city' && (
            <Modal
              popup
              visible
              animationType="slide-up"
              maskClosable={false}
            >
              <div className={styles.headers}>
                {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
                <div
                  role="button"
                  className={styles.headerFont}
                  onClick={this.handleChangeOnclose}
                >
                  取消
                </div>
                <p className={styles.textTwo}>
                  上牌城市
                </p>
                {/* eslint-disable-next-line jsx-a11y/interactive-supports-focus */}
                <div role="button" className={styles.text} onClick={this.handleChangeOk}>
                  确定
                </div>
              </div>
              <div className={styles.pickers}>
                {cityList.map((item, index) => (
                  <PickerView
                    key={item[0]?.value || index}
                    onChange={this.loadArea2.bind(this, index)}
                    data={item}
                    value={cityValue[index]?.value?.split(',')}
                    cascade={false}
                  />
                ))}
              </div>
            </Modal>
          )
        }
      </div>
    );
  }
}
CustomerDetail.propTypes = propTypes;
CustomerDetail.defaultProps = defaultProps;
export default CustomerDetail;
